import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
import { addImportant } from '../../utils/common';
const useStyles = makeStyles()((theme) => ({
    container: Object.assign(Object.assign({ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left', padding: spacing.medium }, (!theme.isFlyingFlowers && {
        [theme.breakpoints.up('sm')]: {
            padding: spacing.large,
        },
    })), { [theme.breakpoints.up('md')]: {
            padding: spacing.xl,
        } }),
    // Title styles
    title: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_lg), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm) }),
    largeSizedTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm) }),
    standardSizedTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm), { [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm) }),
    titleParts: {
        display: 'block',
        textAlign: 'left',
    },
    titlePartsCenter: {
        textAlign: 'center',
    },
    // Alignment helpers
    defaultAlign: {
        marginRight: 'auto',
        textAlign: 'left',
        alignSelf: 'flex-start',
    },
    alignCenter: {
        marginRight: 0,
        textAlign: 'center',
        alignSelf: 'center',
    },
    // Body text
    bodyText: {
        '& h1, & h2, & h3, & h4, & p': Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), { marginBottom: `${spacing.small} !important` }), (theme.isFlyingFlowers && {
            [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, addImportant(theme.typography.medium_regular)), { marginBottom: `${spacing.large} !important` }),
        })), (!theme.isFlyingFlowers && {
            [theme.breakpoints.up('md')]: {},
        })),
    },
    // Button
    button: {
        width: '100%',
        minWidth: '100%',
        marginRight: 'auto',
        [theme.breakpoints.up('sm')]: {
            minWidth: 335,
            width: 'auto',
        },
        '&.MuiButtonBase-root.MuiButton-root > span': {
            padding: 0,
        },
    },
}));
export default useStyles;
